<div class="td-wb-brightcove-player"
     tdWbDataAnalyticsTagging
     [eventSignal]="eventData">
  <div class="td-video-player"
       [attr.data-settings]="dataSettingsString">
    <div class="td-video-embed-code">
      <!-- video player embed code START -->
      <div class="td-wb-brightcove-player__video">
        <video [attr.id]="id"
               [attr.data-video-id]="videoId()"
               [attr.data-account]="account"
               [attr.data-player]="player"
               data-embed="default"
               data-application-id
               class="video-js"
               controls
               playsinline
               #videoPlayer>
        </video>
      </div>
    </div>
  </div>
  @if (showOverlay) {
    <ng-content />
  }
</div>
